import React from "react";
function ProductSelectedImage(props) {
  return <img className="reservar-section-img" src={props.image} alt="" />;
}

export default ProductSelectedImage;
